import { z } from 'zod'

/**
 * A detail of an event that people change by hand and its history keeps.
 *
 * Mirrors the `EventEditField` enum in the Prisma schema (`check:enums`). The
 * guest count, and the vendors put on the event or taken off it: a couple and
 * their planner can change the first, and the planner the second, so the venue
 * needs to see who did. HoneyBook's changes are `EventSyncField`.
 */
export const EVENT_EDIT_FIELDS = ['guest_count', 'vendor_added', 'vendor_removed'] as const

export const eventEditFieldSchema = z.enum(EVENT_EDIT_FIELDS)

export type EventEditField = z.infer<typeof eventEditFieldSchema>
